"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HasWatchList = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.HasWatchList = {
    priority: 1,
    label: 'fields.payload.mor_group_answers.has_watch_list.label',
    fallbackLabel: 'Do you maintain an internal \'watchlist\' to identify previously offboarded merchants in order to ensure previously offboarded parties cannot rejoin?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.Boolean,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
